import { Panel } from '../ui/Panel';
import { Field } from '../ui/Field';
import { inputCls } from '../ui/styles';
import { SettingNumber } from './SettingNumber';
import { SubscriptionSettings } from './SubscriptionSettings';
import { useSettings } from './useSettings';
import { euro } from '../../core/format/currency';

/** Instellingen › Webshop & verzending: verzending, ruilen en het Bewust Abonnement (ook een levering). */
export function ShippingSettings() {
  const {
    policy,
    setPolicy
  } = useSettings();
  return <>
      <Panel title="Verzending" description="Staan in de aankondigingsbalk, de winkelmand, de FAQ en de voorwaarden." data-id="element-4152" data-mp="anw8mqpjd6uo">
        <div className="grid gap-5 sm:grid-cols-2" data-id="element-4153" data-mp="5w4rt7w6mfhq">
          <SettingNumber label="Gratis verzending vanaf (€)" hint="Is meteen de eerste trede van de cadeaus bij bestelling." value={policy.freeShippingFrom} onChange={v => setPolicy('freeShippingFrom', v)} decimals data-id="element-4154" data-mp="yct9v117v4k" />
          <SettingNumber label="Verzendkosten (€)" hint="Daaronder." value={policy.shippingCost} onChange={v => setPolicy('shippingCost', v)} decimals data-id="element-4155" data-mp="tl7beladmiev" />
          <Field label="Vandaag besteld, morgen in huis tot" hint="Tijdstip waarop je de dag afsluit." data-id="element-4156" data-mp="2zctea48jiecs">
            <input type="time" value={policy.orderCutoff} onChange={e => e.target.value && setPolicy('orderCutoff', e.target.value)} className={`${inputCls} sm:max-w-[11rem]`} data-id="element-4157" data-mp="2kop45onjzb5m" />
          </Field>
        </div>
        <p className="mt-6 border-t border-line pt-4 text-[13px] text-muted" data-id="element-4158" data-mp="2fqdrl65vimjp">
          Op de site: “Gratis verzending vanaf {euro(policy.freeShippingFrom)}” · “{policy.returnDays} dagen ruilen op huidadvies” · “Voor {policy.orderCutoff} besteld, morgen in huis”
        </p>
      </Panel>

      <Panel title="Ruilen en nazorg" data-id="element-4159" data-mp="3w3vjkn8p29j7">
        <div className="grid gap-5 sm:grid-cols-2" data-id="element-4160" data-mp="3w56potpm3tdh">
          <SettingNumber label="Ruilen op huidadvies (dagen)" hint="Ook geopend, als het niet bij de huid past." value={policy.returnDays} onChange={v => setPolicy('returnDays', v)} max={365} data-id="element-4161" data-mp="4ym25jyrn3l7" />
          <SettingNumber label="Even vragen hoe het gaat na (weken)" hint="Na een bestelling, voor je eigen opvolging." value={policy.followUpWeeks} onChange={v => setPolicy('followUpWeeks', v)} min={1} max={52} data-id="element-4162" data-mp="3upksvav2qhz8" />
          <SettingNumber label="“Bijna op” vanaf (dagen vooraf)" hint="Dan krijgt de klant een seintje om na te bestellen." value={policy.refillWarnDays} onChange={v => setPolicy('refillWarnDays', v)} max={90} data-id="element-4163" data-mp="m99759w3rhy4" />
        </div>
      </Panel>

      <SubscriptionSettings data-id="element-4164" data-mp="14xw9vlqt3v8j" />
    </>;
}